import script from "./Contents.vue?vue&type=script&lang=ts&setup=true"
export * from "./Contents.vue?vue&type=script&lang=ts&setup=true"

import "./Contents.vue?vue&type=style&index=0&id=5c495e34&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c495e34"]])

export default __exports__